// assets/buddha-fix.js

document.addEventListener('cart:update', function() {
  // Sepet güncellendikten sonra, Budda'nın kendini yenilemesi için 
  // 150 milisaniyelik ufak bir gecikme ekliyoruz. Bu, temanın kendi işlemlerini 
  // bitirmesini sağlar ve çakışmayı önler [citation:3].
  setTimeout(function() {
    // Buddha eklentisi ve onun 'reinit' fonksiyonu mevcutsa çalıştır.
    if (window.BuddhaMegaMenu && typeof window.BuddhaMegaMenu.reinit === 'function') {
      window.BuddhaMegaMenu.reinit();
    }
  }, 150);
});